import {
  DATE_RANGE_PRESET,
  type DateRangePreset,
} from "@/utils/date/dateRangeTypes"

/**
 * Dashboard-level date preference configuration
 * Stored in dashboard.config.datePreferences
 */
export interface DashboardDatePreferences {
  /** Preset key (e.g., "last-14-days") */
  preset?: DateRangePreset

  /** Custom fixed date range (absolute dates) */
  customRange?: {
    start: string // ISO 8601 date string
    end: string // ISO 8601 date string
  }

  /** Relative date range (e.g., "Last 30 days" - recalculated on load) */
  relativeConfig?: {
    amount: number // e.g., 30
    unit: "days" | "weeks" | "months"
  }
}

/**
 * Dashboard configuration stored in dashboard.config JSONB field
 */
export interface DashboardConfig {
  /** Date range preferences for this dashboard */
  datePreferences?: DashboardDatePreferences

  // Future dashboard-level configs can go here
  // e.g., defaultFilters, viewPreferences, theme, etc.
}

/**
 * Default date preset when no preference is saved
 */
export const DEFAULT_DASHBOARD_DATE_PRESET: DateRangePreset =
  DATE_RANGE_PRESET.LAST_7_DAYS
